export const getAutoFillInfo = (professionType, skills) => {
  if (professionType === 'Associate Dentist') {
    return {
      show: false,
      message: 'The Auto-Confirm feature is not available for Associate Dentist at this time.',
    };
  }

  if (!skills.includes('general')) {
    return {
      show: false,
      message:
        'The Auto-Confirm feature is only available for shifts without a specialty preference (General).',
    };
  }

  return {
    show: true,
    message:
      'By turning on auto-confirm, GoTu will match you with an eligible professional. Click the info button for eligibility criteria details.',
  };
};

export const skillCategory = {
  HYG_SPECIALITY: 'category-hyg-specialty',
  DA_SPECIALITY: 'category-da-specialty',
  DN_EXPERIENCED_PROCEDURES: 'category-dn-experienced-procedures',
  SKILLS: 'category-skills',
  INSURANCE_PROVIDER: 'category-insurance-provider',
  SOFTWARE: 'category-software',
};

export const professionSkillMap = {
  RDH: skillCategory.HYG_SPECIALITY,
  DA: skillCategory.DA_SPECIALITY,
  DN: skillCategory.DN_EXPERIENCED_PROCEDURES,
};

const baseUrl = 'https://joingotu.com';

export const Links = {
  home: baseUrl,
  about: `${baseUrl}/about`,
  getHelp: `${baseUrl}/get-help`,
  dentistsSideFaqs: `${baseUrl}/dentists-side-faqs`,
  temporaryStaffing: `${baseUrl}/dental-offices/temporary-staffing`,
  bankPayments: `${baseUrl}/tempmee-bank-payments`,
  privacyPolicy: `${baseUrl}/privacy-policy`,
  termsOfUse: `${baseUrl}/client-terms-of-use`,
  termsOfUseEmployee: `${baseUrl}/w-2-psa/`,
  dentalOffices: `${baseUrl}/dental-offices`,
  hygienist: `${baseUrl}/hygienist`,
  tempmeeBecomingGoTu: `${baseUrl}/blog/tempmee-is-becoming-gotu`,
};

export const paymentHistoryFilterOptions = {
  ALL: 'All',
  CURRENT_MONTH: 'CURRENT_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  LAST_3_MONTHS: 'LAST_3_MONTHS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  YEAR_TO_DATE: 'YEAR_TO_DATE',
  LAST_YEAR: 'LAST_YEAR',
};

export const paymentHistoryFilterOptionsLabels = {
  [paymentHistoryFilterOptions.ALL]: 'All',
  [paymentHistoryFilterOptions.CURRENT_MONTH]: 'Current Month',
  [paymentHistoryFilterOptions.LAST_MONTH]: 'Last Month',
  [paymentHistoryFilterOptions.LAST_3_MONTHS]: 'Last 3 Months',
  [paymentHistoryFilterOptions.LAST_6_MONTHS]: 'Last 6 Months',
  [paymentHistoryFilterOptions.YEAR_TO_DATE]: 'Year to Date',
  [paymentHistoryFilterOptions.LAST_YEAR]: 'Last Year',
};
